import { useTranslation } from "react-i18next";
import { colors, fonts } from "../../../Styles";
import { TooltipString } from "../..";

interface FeedLabel_Props {
  contentString?: string;
  labelColor?: colors;
  noBorder?: boolean;
  tooltip?: boolean;
  cursor?: string;
  width?: string;
  height?: string;
}

export default function FeedLabel({contentString, labelColor, tooltip=false, cursor, width, height, noBorder=false}:FeedLabel_Props) {
  const { t } = useTranslation();

  return (
    <TooltipString
      overrides={{ contentstring: { color: labelColor ? labelColor : colors.greyLightTertiary } }}
      tooltipString={ tooltip ? t(`animalPages.animals.kgFedMore`, {defaultValue:`KG fed more than expected` }) : undefined}
      contentString={
        <div style={{
          border: "1px solid " + ( noBorder ? colors.transparent : labelColor ? labelColor : colors.greyLightTertiary),
          borderRadius: "10px",
          width: width ? width : "50px",
          height: height ? height : "15px",
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: "0",
          cursor: cursor ? cursor : "default",
          ...(contentString ? fonts.fontSize5 : fonts.fontSize4),
        }}>
          {contentString ? contentString : `•••`}
        </div>
      }
    />
  )
}